"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("Utils/redux/actions/constants");
var textFieldOnChange = function (evee, dispatch) {
    var currentInput = evee.target.name;
    var currentPayload = evee.target.value;
    switch (currentInput) {
        case "company":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_COMPANY,
                payload: currentPayload
            });
            break;
        case "date":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_DATE,
                payload: currentPayload
            });
            break;
        case "phone":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_PHONE,
                payload: currentPayload
            });
            break;
        case "fax":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_FAX,
                payload: currentPayload
            });
            break;
        case "street":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_STREET,
                payload: currentPayload
            });
            break;
        case "city":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_CITY,
                payload: currentPayload
            });
            break;
        case "state":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_STATE,
                payload: currentPayload
            });
            break;
        case "zip":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_ZIP,
                payload: currentPayload
            });
            break;
        case "tax":
            dispatch({
                type: constants_1.SET_TYPING_VALUE_TAX,
                payload: currentPayload
            });
            break;
        default:
            break;
    }
};
exports.default = textFieldOnChange;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZnVuY3Rpb25zL2dlbmVyYWwvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFDQSwyREFVdUM7QUFLdkMsSUFBTSxpQkFBaUIsR0FBRyxVQUFDLElBQVcsRUFBRSxRQUF1QjtJQUM3RCxJQUFNLFlBQVksR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQztJQUN0QyxJQUFNLGNBQWMsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQztJQUV6QyxRQUFRLFlBQVksRUFBRTtRQUNwQixLQUFLLFNBQVM7WUFDWixRQUFRLENBQUM7Z0JBQ1AsSUFBSSxFQUFFLG9DQUF3QjtnQkFDOUIsT0FBTyxFQUFFLGNBQWM7YUFDeEIsQ0FBQyxDQUFDO1lBQ0gsTUFBTTtRQUVSLEtBQUssTUFBTTtZQUNULFFBQVEsQ0FBQztnQkFDUCxJQUFJLEVBQUUsaUNBQXFCO2dCQUMzQixPQUFPLEVBQUUsY0FBYzthQUN4QixDQUFDLENBQUM7WUFDSCxNQUFNO1FBRVIsS0FBSyxPQUFPO1lBQ1YsUUFBUSxDQUFDO2dCQUNQLElBQUksRUFBRSxrQ0FBc0I7Z0JBQzVCLE9BQU8sRUFBRSxjQUFjO2FBQ3hCLENBQUMsQ0FBQztZQUNILE1BQU07UUFFUixLQUFLLEtBQUs7WUFDUixRQUFRLENBQUM7Z0JBQ1AsSUFBSSxFQUFFLGdDQUFvQjtnQkFDMUIsT0FBTyxFQUFFLGNBQWM7YUFDeEIsQ0FBQyxDQUFDO1lBQ0gsTUFBTTtRQUVSLEtBQUssUUFBUTtZQUNYLFFBQVEsQ0FBQztnQkFDUCxJQUFJLEVBQUUsbUNBQXVCO2dCQUM3QixPQUFPLEVBQUUsY0FBYzthQUN4QixDQUFDLENBQUM7WUFDSCxNQUFNO1FBRVIsS0FBSyxNQUFNO1lBQ1QsUUFBUSxDQUFDO2dCQUNQLElBQUksRUFBRSxpQ0FBcUI7Z0JBQzNCLE9BQU8sRUFBRSxjQUFjO2FBQ3hCLENBQUMsQ0FBQztZQUNILE1BQU07UUFFUixLQUFLLE9BQU87WUFDVixRQUFRLENBQUM7Z0JBQ1AsSUFBSSxFQUFFLGtDQUFzQjtnQkFDNUIsT0FBTyxFQUFFLGNBQWM7YUFDeEIsQ0FBQyxDQUFDO1lBQ0gsTUFBTTtRQUVSLEtBQUssS0FBSztZQUNSLFFBQVEsQ0FBQztnQkFDUCxJQUFJLEVBQUUsZ0NBQW9CO2dCQUMxQixPQUFPLEVBQUUsY0FBYzthQUN4QixDQUFDLENBQUM7WUFDSCxNQUFNO1FBRVIsS0FBSyxLQUFLO1lBQ1IsUUFBUSxDQUFDO2dCQUNQLElBQUksRUFBRSxnQ0FBb0I7Z0JBQzFCLE9BQU8sRUFBRSxjQUFjO2FBQ3hCLENBQUMsQ0FBQztZQUNILE1BQU07UUFFUjtZQUNFLE1BQU07S0FDVDtBQUNILENBQUMsQ0FBQztBQUVGLGtCQUFlLGlCQUFpQixDQUFDIn0=